define('modules/pagination/pagination_model',['backbone'], function (Backbone) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: {
      offset: 0,
      limit: 10,
      total: false,
      pages: 0,
      originalLimit: 0
    }
  });

  return Model;
});
